import { render } from "./newPT.vue?vue&type=template&id=7b767642"
import script from "./newPT.vue?vue&type=script&lang=js"
export * from "./newPT.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__